import http from "../../http-common";
/* eslint-disable */
class AgendaPelatihanService {
  agendaPelatihan(page, itemPerPage, keyword) {
    return http.get("/agenda-pelatihan", {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  create(data) {
    var bodyFormData = new FormData();

    if (data.poster_url != null) bodyFormData.append("photo", data.poster_url);

    return http.post("/agenda-pelatihan", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    if (data.poster_url != null) bodyFormData.append("photo", data.poster_url);

    return http.put(`/agenda-pelatihan/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new AgendaPelatihanService();
